/* eslint-disable jira/filename-case */
/**
 * The types of entity limits for a project
 */
export const ENTITY_LIMIT_TYPE = {
	COMMENTS_PER_VIEW: 'commentsPerView',
	FIELDS_PER_PROJECT: 'fieldsPerProject',
	FIELDS_PER_VIEW: 'fieldsPerView',
	IDEAS_SEARCH_MAX_RESULTS: 'ideasSearchMaxResults',
	INSIGHTS_PER_IDEA: 'insightsPerIdea',
	INSIGHTS_PER_PROJECT: 'insightsPerProject',
	LABELS_PER_SNIPPET: 'labelsPerSnippet',
	OPTIONS_PER_FIELD: 'optionsPerField',
	PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
	PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
	PLAYS_PER_PROJECT: 'playsPerProject',
	SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
	VIEWS_PER_PROJECT: 'viewsPerProject',
	VIEWSETS_PER_PROJECT: 'viewsetsPerProject',
} as const;

// Backend templates return the incorrect template keys, that FE not accepts.
// We map them to correct ones.
// Temporary solution until we have a new restore mechanism.
export const TEMPORARY_PROJECT_TEMPLATE_KEYS = {
	OPPORTUNITY_SOLUTION: 'jira.polaris.opportunity-solution',
	PORTFOLIO_ROADMAP: 'jira.polaris.portfolio-roadmap',
} as const;
